import { useMemo } from 'react';
import { type FieldError, type UseFormReturn } from 'react-hook-form';
import { getReactHookFormErrorMessages } from '@/shared/utils';
import { useTranslation } from 'react-i18next';

const usePasswordChecks = <
  T extends { password: string; [key: string]: unknown },
>(
  form: UseFormReturn<T>
) => {
  const { t } = useTranslation();

  const passwordChecks = useMemo(
    () => [
      t('authPages.validation.passwordRules.minLength'),
      t('authPages.validation.passwordRules.uppercaseLowercase'),
      t('authPages.validation.passwordRules.digit'),
      t('authPages.validation.passwordRules.specialChars'),
    ],
    [t]
  );

  const unmetPasswordChecks = getReactHookFormErrorMessages(
    form.formState.errors.password as FieldError | undefined
  );

  return { passwordChecks, unmetPasswordChecks };
};

export { usePasswordChecks };
